/* Generated from snippets/rakhi-pdp-revamp.liquid. CDN asset, loaded with
   `defer`. Every entry point in here already checks document.readyState, so
   deferring is behaviour-identical to the old inline version. */

/* ---------------------------------------------------------------------------
   Rakhi PDP gate.

   Every module below used to test location.pathname for /rakhi|raksha/. That
   only ever matched the product HANDLE, while the Liquid guard in theme.liquid
   is much broader (title, type, vendor, tags, collection membership). The two
   disagreed on plenty of products.

   Now that theme.liquid puts `rk-pdp-on` on <html> server-side, that class is
   the single source of truth: if it is there, Liquid decided this is a Rakhi
   PDP and the CSS is already applied, so the JS must run to build the pieces
   the CSS expects. The pathname test is kept as a fallback for the case where
   the class is missing (e.g. an older cached layout).
   --------------------------------------------------------------------------- */
window.__rkIsRakhiPdp = window.__rkIsRakhiPdp || function (p) {
  if (document.documentElement.classList.contains('rk-pdp-on')) return true;
  p = p || location.pathname.replace(/\/$/, "").toLowerCase();
  return p.indexOf("/products/") !== -1 && /rakhi|raksha/.test(p);
};

// New PDP Revamp Designs 
// ===== New PDP <Rakhi Info Column> Start =====
function executeRakhiPdpInfo() {

  var CFG = {
    EYEBROW:         'RAKSHA BANDHAN SPECIAL',
    PROMISE_TITLE:   'Order early for a timely rakhi delivery',
    PROMISE_ORDERBY: '28 Aug',
    PROMISE_TAIL:    'dispatched in 24 hrs',
    PROMISE_PILL:    'On time',
    QTY_LABEL:       'Quantity',
    TRUST: [                                  
      { i: 'ret',   t: 'easy returns',    s: 'easy returns' },
      { i: 'lock',  t: 'Secure Payment',        s: 'Secure Payment' },
      { i: 'truck', t: 'Dispatched in 24 hrs',  s: 'Dispatched in 24 hrs' }
    ],
    JOURNEY: ['Order Today', 'Order Ready', 'Delivered'],
    DELIVERED_PREFIX: 'By ',
    CHECKOUT_NOTE:   'Guaranteed safe & secure checkout',
    PAY_LABEL:       'We accept',
    /* strings render as text chips, objects render as images */
    PAY: [
      { alt: 'VISA',       src: 'https://cdn.shopify.com/s/files/1/0782/3284/6646/files/Frame_328.png?v=1784640137' },
      { alt: 'Mastercard', src: 'https://cdn.shopify.com/s/files/1/0782/3284/6646/files/Frame_321.png?v=1784640137' },
      { alt: 'NetBanking',      src: 'https://cdn.shopify.com/s/files/1/0782/3284/6646/files/Frame_331.png?v=1784640138' },
      { alt: 'UPI',        src: 'https://cdn.shopify.com/s/files/1/0782/3284/6646/files/Frame_330.png?v=1784640138' }
    ],
    SHOW_WISHLIST:   false,   
    SHOW_SHARE:      false,   
    KEEP_QTY:        false    
  };
 
  var ICO = {
    truck: '<path d="M14 18V6a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    ret:   '<path d="M3 12a9 9 0 1 0 3-6.7L3 8"/><path d="M3 3v5h5"/>',
    lock:  '<rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
    bag:   '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    box:   '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>',
    home:  '<path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M9 22V12h6v10"/>'
  };

  function svg(key, size, sw) {
    return '<svg viewBox="0 0 24 24" width="' + (size || 18) + '" height="' + (size || 18) +
      '" fill="none" stroke="currentColor" stroke-width="' + (sw || 1.7) +
      '" stroke-linecap="round" stroke-linejoin="round">' + ICO[key] + '</svg>';
  }

  var STAR = 'M12 2.6l2.72 5.86 6.28.72-4.68 4.3 1.3 6.22L12 16.6 6.38 19.7l1.3-6.22-4.68-4.3 6.28-.72z';

  function starsSVG(avg) {
    var out = '<svg class="rk-pdp-stars" viewBox="0 0 118 24" width="94" height="19" aria-hidden="true">' +
      '<defs><linearGradient id="rkpHalfStar" x1="0" x2="1" y1="0" y2="0">' +
      '<stop offset="50%" stop-color="currentColor"/>' +
      '<stop offset="50%" stop-color="currentColor" stop-opacity="0"/></linearGradient></defs>';
    for (var i = 0; i < 5; i++) {
      var d = avg - i;
      var f = d >= 0.75 ? 'currentColor' : (d >= 0.25 ? 'url(#rkpHalfStar)' : 'none');
      out += '<g transform="translate(' + (i * 24) + ',0)"><path d="' + STAR +
             '" fill="' + f + '" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/></g>';
    }
    return out + '</svg>';
  }

  function buildRating(meta) {
    if (!meta) return;
    var badge = document.querySelector('.jdgm-prev-badge');
    if (!badge) return;
    var avg = parseFloat(badge.getAttribute('data-average-rating') || '0');
    var n = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
    if (!n || isNaN(n)) return;                       

    var el = document.getElementById('rk-pdp-rating');
    if (!el) {
      el = document.createElement('span');
      el.id = 'rk-pdp-rating';
      el.className = 'rk-pdp-rating';
      el.innerHTML = '<span class="rk-pdp-stars-wrap"></span><span class="rk-pdp-reviews"></span>';
    }
    if (el.parentNode !== meta) meta.appendChild(el);

    var sw = el.querySelector('.rk-pdp-stars-wrap');
    if (sw && sw.getAttribute('data-avg') !== String(avg)) {
      sw.setAttribute('data-avg', String(avg));
      sw.innerHTML = starsSVG(isNaN(avg) ? 0 : avg);
    }
    var rv = el.querySelector('.rk-pdp-reviews');
    var txt = n + (n === 1 ? ' review' : ' reviews');
    if (rv && rv.textContent !== txt) rv.textContent = txt;

    meta.classList.add('rk-has-rating');

    if (!el._rkBound) {
      el._rkBound = true;
      rv.addEventListener('click', function () {
        var t = document.querySelector('#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-review-widget');
        if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function hide(el) {
    if (el && el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
  }


  function neutralisePlpLeaks() {
    if (!window._rk_pdp_leaks_done) {
      window._rk_pdp_leaks_done = true;
      [
        '_crowai_obs_44370136',         
        '_crowai_obs_mfilters',         
        '_crowai_obs_countdown_cp01',   
        '_crowai_obs_eyebrow_f741f167', 
        '_crowai_obs_62745110'          
      ].forEach(function (k) {
        try { if (window[k] && window[k].disconnect) window[k].disconnect(); } catch (e) {}
        window[k] = null;
      });
      if (window._cp_cd_int) { clearInterval(window._cp_cd_int); window._cp_cd_int = null; }
    }
    var leaks = ['.cp-eyebrow', '.cp-m-toolbar-wrap', '.cp-m-overlay', '.cp-m-sheet',
                 '.cp-cd-wrap', '#crowai-title-right-panel'];
    for (var i = 0; i < leaks.length; i++) {
      var list = document.querySelectorAll(leaks[i]);
      for (var j = 0; j < list.length; j++) hide(list[j]);
    }
    document.documentElement.classList.remove('cp-m-lock');
  }

  function releaseTitle(info) {
    var h1 = info.querySelector('.product__title h1');
    if (!h1 || !h1.getAttribute('style')) return;
    ['font-family', 'color', 'font-weight', 'padding', 'text-align',
     'text-transform', 'line-height', 'letter-spacing', 'font-size']
      .forEach(function (p) { h1.style.removeProperty(p); });
    if (!h1.getAttribute('style')) h1.removeAttribute('style');
  }

  
  function placeBefore(node, anchor) {
    if (!anchor || !anchor.parentNode) return;
    if (anchor.previousElementSibling !== node) anchor.parentNode.insertBefore(node, anchor);
  }
  
  function placeAfter(node, anchor) {
    if (!anchor || !anchor.parentNode) return;
    if (anchor.nextElementSibling !== node) anchor.parentNode.insertBefore(node, anchor.nextElementSibling);
  }

  function mk(id, cls, html) {
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.className = cls;
      if (html) el.innerHTML = html;
    }
    return el;
  }

  
  function fmtDate(raw, which) {
    if (!raw) return '';
    var parts = String(raw).split(/[-–—]/).map(function (s) { return s.trim(); }).filter(Boolean);
    var pick = (which === 'last') ? parts[parts.length - 1] : parts[0];
    if (!pick) return String(raw).trim();
    var m = pick.match(/([A-Za-z]{3,})\s*(\d{1,2})/) || pick.match(/(\d{1,2})\s*([A-Za-z]{3,})/);
    if (!m) return pick;
    var mon, day;
    if (/^[A-Za-z]/.test(m[1])) { mon = m[1]; day = m[2]; } else { day = m[1]; mon = m[2]; }
    return day + ' ' + mon.slice(0, 3);
  }

  function readDates() {
    var t = document.getElementById('ordertoday');
    var r = document.getElementById('orderready');
    var d = document.getElementById('orderdelivery');
    if (t || r || d) {
      return [
        fmtDate(t ? t.textContent : '', 'first'),
        fmtDate(r ? r.textContent : '', 'first'),
        d ? CFG.DELIVERED_PREFIX + fmtDate(d.textContent, 'last') : ''
      ];
    }
    var boxes = document.querySelectorAll('.order-delivery .order-box');
    var out = ['', '', ''];
    for (var i = 0; i < boxes.length && i < 3; i++) {
      var h5 = boxes[i].querySelector('h5');
      var v = h5 ? h5.textContent : '';
      out[i] = (i === 2) ? CFG.DELIVERED_PREFIX + fmtDate(v, 'last') : fmtDate(v, 'first');
    }
    return out;
  }


  function buildEyebrow(info) {
    var title = info.querySelector('.product__title');
    if (!title) return;
    var el = mk('rk-pdp-eyebrow', 'rk-pdp-eyebrow',
      '<span class="rk-pdp-eyebrow-line"></span><span class="rk-pdp-eyebrow-txt"></span>');
    var txt = el.querySelector('.rk-pdp-eyebrow-txt');
    if (txt && txt.textContent !== CFG.EYEBROW) txt.textContent = CFG.EYEBROW;
    placeBefore(el, title);
  }

  function buildMeta(info) {
    var vendor = info.querySelector('.product-vendor');
    var badge  = info.querySelector('[id*="judge_me_reviews_preview_badge"]');
    var anchor = info.querySelector('.pmi') || info.querySelector('.bdgg-price');
    if (!vendor && !badge) return null;
    var el = mk('rk-pdp-meta', 'rk-pdp-meta', '');
    if (vendor && vendor.parentNode !== el) el.appendChild(vendor);
    if (badge && badge.parentNode !== el) el.appendChild(badge);
    if (anchor) placeBefore(el, anchor);
    else if (vendor || badge) info.appendChild(el);
    return el;
  }

  
  function fixSku(info) {
    var v = info.querySelector('.pmi [data-pmi-value="sku"]');
    if (v && v.title && v.textContent !== v.title) v.textContent = v.title;
  }

  
  function atcWrapper(info) {
    var pf = info.querySelector('product-form');
    if (!pf) return null;
    var n = pf;
    while (n && n.parentNode && n.parentNode !== info) n = n.parentNode;
    return (n && n.parentNode === info) ? n : null;
  }

  function buildPromise(info, wrap) {
    if (!wrap) return;
    var el = mk('rk-pdp-promise', 'rk-pdp-promise',
      '<span class="rk-pdp-promise-ico">' + svg('truck', 20, 1.6) + '</span>' +
      '<div class="rk-pdp-promise-txt">' +
        '<div class="rk-pdp-promise-t"></div>' +
      '</div>' +
      '<span class="rk-pdp-promise-pill"><span class="rk-pdp-dot"></span><em></em></span>');
    var t = el.querySelector('.rk-pdp-promise-t');
    var b = el.querySelector('.rk-pdp-promise-s b');
    var i = el.querySelector('.rk-pdp-promise-s i');
    var p = el.querySelector('.rk-pdp-promise-pill em');
    if (t && t.textContent !== CFG.PROMISE_TITLE) t.textContent = CFG.PROMISE_TITLE;
    if (b && b.textContent !== CFG.PROMISE_ORDERBY) b.textContent = CFG.PROMISE_ORDERBY;
    if (i && i.textContent !== CFG.PROMISE_TAIL) i.textContent = CFG.PROMISE_TAIL;
    if (p && p.textContent !== CFG.PROMISE_PILL) p.textContent = CFG.PROMISE_PILL;
    placeBefore(el, wrap);
  }

  function reorderButtons(info) {
    var part = info.querySelector('.buy-btn-part');
    var buy  = info.querySelector('#gokwik-buy-now, .custom-buy-btn');
    if (!part || !buy) return;
    if (buy.parentNode !== part) part.insertBefore(buy, part.firstChild);
    else if (part.firstElementChild !== buy) part.insertBefore(buy, part.firstChild);
  }

  function tailHTML() {
    var trust = '';
    for (var i = 0; i < CFG.TRUST.length; i++) {
      trust += '<span class="rk-pdp-trust-i">' + svg(CFG.TRUST[i].i, 17, 1.6) +
               '<em class="rk-pdp-t-lg">' + CFG.TRUST[i].t + '</em>' +
               '<em class="rk-pdp-t-sm">' + (CFG.TRUST[i].s || CFG.TRUST[i].t) + '</em></span>';
    }
    var steps = ['bag', 'box', 'home'];
    var jr = '';
    for (var j = 0; j < 3; j++) {
      jr += '<div class="rk-pdp-jr-step' + (j < 2 ? ' is-done' : '') + '">' +
              '<span class="rk-pdp-jr-node">' + svg(steps[j], 18, 1.6) + '</span>' +
              '<span class="rk-pdp-jr-lbl">' + CFG.JOURNEY[j] + '</span>' +
              '<span class="rk-pdp-jr-date" data-rk-jr="' + j + '"></span>' +
            '</div>';
    }
    // var pay = '';
    // for (var k = 0; k < CFG.PAY.length; k++) pay += '<span class="rk-pdp-pay-c">' + CFG.PAY[k] + '</span>';
    var pay = '';
    for (var k = 0; k < CFG.PAY.length; k++) {
      var pc = CFG.PAY[k];
      pay += '<span class="rk-pdp-pay-c rk-pdp-pay-img">' +
               '<img src="' + pc.src + '" alt="' + (pc.alt || '') + '" loading="lazy" decoding="async">' +
             '</span>';
    }

    return '<div class="rk-pdp-trust">' + trust + '</div>' +
           '<div class="rk-pdp-jr">' +
             '<div class="rk-pdp-jr-track"><span class="rk-pdp-jr-fill"></span></div>' +
             '<div class="rk-pdp-jr-steps">' + jr + '</div>' +
           '</div>' +
           '<div class="rk-pdp-note">' + svg('lock', 14, 1.8) + '<em>' + CFG.CHECKOUT_NOTE + '</em></div>' +
           '<div class="rk-pdp-pay"><span class="rk-pdp-pay-l">' + CFG.PAY_LABEL + '</span>' + pay + '</div>';
  }

  function buildTail(info, wrap) {
    if (!wrap) return;
    var el = mk('rk-pdp-tail', 'rk-pdp-tail', tailHTML());
    placeAfter(el, wrap);
    var dates = readDates();
    dates[2] = 'Soon';
    var nodes = el.querySelectorAll('[data-rk-jr]');
    for (var i = 0; i < nodes.length; i++) {
      var v = dates[Number(nodes[i].getAttribute('data-rk-jr'))] || '';
      if (nodes[i].textContent !== v) nodes[i].textContent = v;
    }
  }

  function restoreQty(info) {
    if (!CFG.KEEP_QTY) return;
    var input = info.querySelector('.custom-quantity-input[name="quantity"]');
    if (!input) return;

    if (!window._rkPdpQtyBound) {
      window._rkPdpQtyBound = true;
      document.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('.buy-btn-part .product-form__submit');
        if (!b) return;
        var q = document.querySelector('.custom-quantity-input[name="quantity"]');
        if (q) window._rkPdpQty = q.value;
      }, true);
    }

    var keep = window._rkPdpQty;
    if (keep && Number(keep) > 1 && input.value === '1' &&
        input.getAttribute('data-rk-kept') !== String(keep)) {
      input.setAttribute('data-rk-kept', String(keep));
      input.value = keep;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function hideOld(info) {
    var sels = [
      '.product__title .cp-m-toolbar-wrap',
      '.cg-free-shipping-card',
      '.bdgg',
      '.new-badges-pdp-wraper',
      '#crowai-urgency-timer',
      '#crowai-trust-widget-4ad289a2',
      '.product__view-details'
    ];
    if (!CFG.SHOW_WISHLIST) sels.push('.custom-wish-pdp');
    if (!CFG.SHOW_SHARE) { sels.push('share-button'); sels.push('.share-buttons--list'); }
    for (var i = 0; i < sels.length; i++) {
      var list = info.querySelectorAll(sels[i]);
      for (var j = 0; j < list.length; j++) hide(list[j]);
    }
    /* .order-delivery must NOT be display:none'd: its <svg> holds the
       pattern/clipPath <defs> (pattern0_736_371 etc.) that the quick-view
       modal's copies of the same SVGs reference by id (the theme's
       quick-add.js only renames section-id based ids, so the modal's SVG
       refs resolve to the FIRST document occurrence — this one). A
       display:none subtree never paints, which turned the modal's journey
       icons into blank navy blobs. Instead collapse it to a 0x0 invisible
       box so the defs keep painting. Only the MAIN page copies are
       collapsed — anything inside the quick-view modal stays visible. */
    var ods = document.querySelectorAll('.order-delivery');
    for (var k = 0; k < ods.length; k++) {
      var od = ods[k];
      if (od.closest && od.closest('quick-add-modal, .quick-add-modal')) continue;
      if (od.style.display === 'none') od.style.removeProperty('display');
      if (!od.classList.contains('rk-svg-hidden')) od.classList.add('rk-svg-hidden');
    }
    var ut = document.getElementById('crowai-urgency-timer');
    if (ut) hide(ut);
  }

  
  function apply() {
    var sec = document.querySelector('product-info');
    if (!sec) return;
    var info = sec.querySelector('[id^="ProductInfo-"]');
    if (!info) return;

    document.documentElement.classList.add('rk-pdp-on');

    neutralisePlpLeaks();
    releaseTitle(info);
    hideOld(info);
    buildEyebrow(info);
    buildRating(buildMeta(info));
    fixSku(info);
    var wrap = atcWrapper(info);
    buildPromise(info, wrap);
    reorderButtons(info);
    buildTail(info, wrap);
    restoreQty(info);
  }

  apply();
  
  [60, 300, 1200].forEach(function (ms) { setTimeout(apply, ms); });

  if (window._crowai_obs_rkpdp_info) window._crowai_obs_rkpdp_info.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_info = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var root = document.querySelector('product-info') || document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_info.observe(root, { childList: true, subtree: true });
}

(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiPdpInfo();
  else document.addEventListener("DOMContentLoaded", executeRakhiPdpInfo);
})();
// ===== New PDP <Rakhi Info Column> End =====



// ===== New PDP <Make This Rakhi Special> Start =====
function executeRakhiPdpAddons() {

  
  var CFG = {
    HEADING: 'Make This Rakhi Special',

    /* DYNAMIC SOURCE — the cards are pulled from this collection instead of
       a fixed list. Each product page shows a DIFFERENT set of 3 (rotation
       is seeded by the product handle, so it's stable per product but
       varies across products). Change the handle to re-point the block. */
    COLLECTION: 'chocolate',
    COLLECTION_LIMIT: 50,   /* rotation pool = first N products of the collection (max 250) */
    COUNT: 3,               /* how many cards to show */

    /* FALLBACK ONLY — used if the collection can't be fetched or is empty */
    PRODUCTS: [
      { handle: 'multicolor-round-rakhi-chocolate-almonds-32gm-with-roli-chawal-silver-color-pooja-coin-greeting-card-rakhi-with-chocolate-rakshbandhan-combo-pack-of-5-for-raksha-bandhan-23001556', variant: 54209915027766 },
      { handle: 'multicolor-om-rakhi-chocolate-magic-96gm-with-roli-chawal-silver-color-pooja-coin-greeting-card-fancy-rakhis-for-men-stylish-rakshbandhan-combo-pack-of-5-for-raksha-bandhan',            variant: 54187369890102 },
      { handle: 'ganesh-rakhi-combo-raksha-bandhan-gift-with-choco-magic-standy-pouch-pack-of-7',                                                                                                        variant: 54227929891126 }
    ],
    HIDE_SELF: true,
    HIDE_SOLD_OUT: true,
    MONEY: 'Rs. '
  };

  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var v = (Number(cents) / 100).toFixed(2).replace(/\.00$/, '');
    return CFG.MONEY + v;
  }

  function thumb(url, px) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + px + 'x' + px + '_crop_center$1$2');
  }

  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1].toLowerCase() : '';
  }

  window._rkAddonCache = window._rkAddonCache || {};

  function fetchProduct(handle) {
    if (window._rkAddonCache[handle]) return Promise.resolve(window._rkAddonCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { window._rkAddonCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function shell() {
    return '<div class="rk-ad-inner page-width">' +
             '<h2 class="rk-ad-head"></h2>' +
             '<div class="rk-ad-grid"></div>' +
           '</div>';
  }

  function cardHTML(item) {
    var p = item.product, v = item.variant;
    var cmp = (v.compare_at_price && v.compare_at_price > v.price)
      ? '<s class="rk-ad-was">' + money(v.compare_at_price) + '</s>' : '';
    return '<article class="rk-ad-card" data-rk-ad-handle="' + p.handle + '">' +
             '<a class="rk-ad-media" href="/products/' + p.handle + '?variant=' + v.id + '">' +
               '<img src="' + thumb(p.featured_image, 200) + '" alt="" loading="lazy" width="86" height="86">' +
             '</a>' +
             '<div class="rk-ad-body">' +
               '<a class="rk-ad-title" href="/products/' + p.handle + '?variant=' + v.id + '">' + p.title + '</a>' +
               '<div class="rk-ad-price"><span class="rk-ad-now">' + money(v.price) + '</span>' + cmp + '</div>' +
             '</div>' +
             '<button type="button" class="rk-ad-add" data-rk-ad-id="' + v.id + '" aria-label="Add ' + p.title + ' to cart">' +
               '<svg class="rk-ad-plus" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>' +
               '<svg class="rk-ad-tick" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
             '</button>' +
           '</article>';
  }

  /* ---------------- add to cart (native <cart-drawer>, same as the PLP stepper) ---- */
  function addToCart(id, btn) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: SECTIONS,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && json && json.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(json);
          if (typeof drawer.open === 'function') drawer.open();
        }
        btn.classList.remove('is-busy');
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
      })
      .catch(function () { btn.classList.remove('is-busy'); });
  }

  /* ---------------- dynamic source: collection + per-product rotation ---- */
  function fetchCollectionHandles() {
    if (window._rkAddonCollHandles) return Promise.resolve(window._rkAddonCollHandles);
    return fetch('/collections/' + CFG.COLLECTION + '/products.json?limit=' + (CFG.COLLECTION_LIMIT || 50),
                 { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var out = [];
        var ps = (d && d.products) || [];
        for (var i = 0; i < ps.length; i++) {
          var p = ps[i];
          if (!p || !p.handle || !p.variants || !p.variants.length) continue;
          if (CFG.HIDE_SOLD_OUT) {
            var ok = false;
            for (var j = 0; j < p.variants.length; j++) {
              if (p.variants[j].available !== false) { ok = true; break; }
            }
            if (!ok) continue;
          }
          out.push(p.handle);
        }
        window._rkAddonCollHandles = out;
        return out;
      })
      .catch(function () { return []; });
  }

  /* deterministic per-product offset: the SAME product always shows the
     same add-ons (stable, cache-friendly), but DIFFERENT products land on
     different offsets, so the block rotates through the whole pool */
  function seedOffset(str, n) {
    var h = 0;
    for (var i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
    return n > 0 ? h % n : 0;
  }

  /* ---------------- build ---------------- */
  function fill(root) {
    if (root.getAttribute('data-rk-filled') === '1') return;
    if (root.getAttribute('data-rk-filling') === '1') return;   /* fetch already in flight */
    root.setAttribute('data-rk-filling', '1');
    var here = currentHandle();

    fetchCollectionHandles().then(function (handles) {
      handles = handles.filter(function (h) {
        return !(CFG.HIDE_SELF && h.toLowerCase() === here);
      });

      var picks = [];
      if (handles.length) {
        /* rotation window seeded by the current product; we take 2× the
           needed count as spares so sold-out/unpublished drops still leave
           a full row */
        var off = seedOffset(here || 'rakhi', handles.length);
        var wanted = Math.min(handles.length, (CFG.COUNT || 3) * 2);
        for (var i = 0; i < wanted; i++) picks.push({ handle: handles[(off + i) % handles.length] });
      } else {
        /* collection unreachable or empty → static fallback list */
        picks = CFG.PRODUCTS.filter(function (x) {
          return !(CFG.HIDE_SELF && x.handle.toLowerCase() === here);
        });
      }
      if (!picks.length) { root.setAttribute('data-rk-filled', '1'); root.removeAttribute('data-rk-filling'); hide(root); return; }

      Promise.all(picks.map(function (x) { return fetchProduct(x.handle); }))
        .then(function (products) {
          var items = [];
          for (var i = 0; i < products.length && items.length < (CFG.COUNT || 3); i++) {
            var p = products[i];
            if (!p || !p.variants || !p.variants.length) continue;
            var want = picks[i].variant;
            var v = null;
            for (var j = 0; j < p.variants.length; j++) {
              if (want && String(p.variants[j].id) === String(want)) { v = p.variants[j]; break; }
            }
            if (!v) v = p.variants[0];
            if (CFG.HIDE_SOLD_OUT && v.available === false) continue;
            items.push({ product: p, variant: v });
          }
          var grid = root.querySelector('.rk-ad-grid');
          if (!grid) { root.removeAttribute('data-rk-filling'); return; }
          if (!items.length) { root.removeAttribute('data-rk-filling'); hide(root); return; }
          grid.innerHTML = items.map(cardHTML).join('');
          root.setAttribute('data-rk-filled', '1');
          root.removeAttribute('data-rk-filling');
          root.classList.add('is-ready');
        });
    });
  }

  function hide(el) {
    if (el && el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
  }

  function anchor() {
    var pi = document.querySelector('product-info');
    if (!pi) return null;
    return pi.closest('.shopify-section') || pi;
  }

  function apply() {
    var after = anchor();
    if (!after || !after.parentNode) return;

    var root = document.getElementById('rk-pdp-addons');
    if (!root) {
      root = document.createElement('section');
      root.id = 'rk-pdp-addons';
      root.className = 'rk-pdp-addons';
      root.innerHTML = shell();
      var h = root.querySelector('.rk-ad-head');
      if (h) h.textContent = CFG.HEADING;
    }
    /* sits directly after the product section, every run */
    if (after.nextElementSibling !== root) after.parentNode.insertBefore(root, after.nextElementSibling);

    fill(root);
  }

  apply();

  /* one delegated handler for the whole section */
  if (!window._rkAddonBound) {
    window._rkAddonBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.rk-ad-add');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-rk-ad-id');
      if (id) addToCart(id, btn);
    });
  }

  if (window._crowai_obs_rkpdp_addons) window._crowai_obs_rkpdp_addons.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_addons = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var obsRoot = document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_addons.observe(obsRoot, { childList: true, subtree: false });
}
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiPdpAddons();
  else document.addEventListener("DOMContentLoaded", executeRakhiPdpAddons);
})();
// ===== New PDP <Make This Rakhi Special> End =====


// ===== New PDP <You May Also Like — PLP card design> Start =====
function executeRakhiPdpRelated() {

  /* ---------------- EDITABLE CONFIG ---------------- */
  var CFG = {
    SHOW_BEST_SELLER: true   // false = hide the teal "Best Seller" ribbon on these cards
  };
  /* ------------------------------------------------- */

  function section() {
    var pr = document.querySelector('product-recommendations');
    if (!pr) return null;
    return pr.closest('.shopify-section') || pr;
  }

  function cards() {
    return document.querySelectorAll(
      'product-recommendations .grid.product-grid > li, product-recommendations .related_product_slider > li'
    );
  }

  /* 1. the one line that makes your PLP code adopt these cards */
  function tag(li) {
    var card = li.querySelector('.card') || li.querySelector('.card-wrapper');
    if (card && !card.classList.contains('card-coll-new')) card.classList.add('card-coll-new');
    return card;
  }

  function ensureBadge(card) {
    if (!card || card.querySelector('.discount-badge')) return;
    var inner = card.querySelector('.card__inner');
    if (!inner) return;

    var pct = '';
    var ov = card.querySelector('.custom-discount-overlay');
    if (ov) { var m = ov.textContent.match(/(\d+)/); if (m) pct = m[1]; }

    if (!pct) {                                    // fall back to computing it
      var num = function (el) {
        if (!el) return 0;
        var t = String(el.textContent).replace(/[^\d.]/g, '');
        return parseFloat(t) || 0;
      };
      var sp = num(card.querySelector('.sale-price, .price-item--sale'));
      var cp = num(card.querySelector('.compare-price s, .compare-price, .price-item--regular'));
      if (sp > 0 && cp > sp) pct = String(Math.round((1 - sp / cp) * 100));
    }
    if (!pct) return;

    var b = document.createElement('span');
    b.className = 'discount-badge';
    b.textContent = pct + '% OFF';
    inner.insertBefore(b, inner.firstChild);
  }

  function fixOrder(card) {
    if (!card) return;
    var divider = card.querySelector('.cp-card-divider');
    var atc = card.querySelector('.product-card-buttons.new-atc');
    if (!divider || !atc || !divider.parentNode) return;
    if (divider.nextElementSibling !== atc) {
      divider.parentNode.insertBefore(atc, divider.nextSibling);
    }
  }

  function apply() {
    var sec = section();
    if (!sec) return;
    if (!sec.classList.contains('rk-pdp-rel')) sec.classList.add('rk-pdp-rel');
    sec.classList.toggle('rk-rel-no-bs', !CFG.SHOW_BEST_SELLER);

    var list = cards();
    if (!list.length) return;
    for (var i = 0; i < list.length; i++) {
      var card = tag(list[i]);
      ensureBadge(card);
      fixOrder(card);
    }
  }

  apply();

  if (window._crowai_obs_rkpdp_related) window._crowai_obs_rkpdp_related.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_related = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var obsRoot = document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_related.observe(obsRoot, { childList: true, subtree: true });
}
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiPdpRelated();
  else document.addEventListener("DOMContentLoaded", executeRakhiPdpRelated);
})();
// ===== New PDP <You May Also Like — PLP card design> End =====


// ===== New PDP <Experience The Similar Products — Whatmore> Start =====
function executeRakhiPdpWhatmore() {

  /* ---------------- EDITABLE CONFIG ---------------- */
  var CFG = {
  HEADING_MATCH: 'similar products',
  HEADING_SIZE:  { d: '40px', m: '26px' },   // was { d: '46px', m: '32px' }
  TILE_RADIUS:   '14px',
  BADGE_STYLE:   'green'
};
  /* ------------------------------------------------- */

  var T = {
    navy: '#121F4A', gray: '#6F7589', maroon: '#8A2830',
    gold: '#C3A342', green: '#1E7A45', greenBg: '#E8F5EC',
    serif: "'Cormorant Garamond', serif"
  };

  function set(el, props) {
    if (!el) return;
    for (var k in props) if (props.hasOwnProperty(k)) el.style.setProperty(k, props[k], 'important');
  }
  function isMobile() { return window.matchMedia('(max-width:749px)').matches; }

  function root() { return document.querySelector('.whatmore-carousel-events'); }

  function styleHeading(r) {
  var ps = r.querySelectorAll('p');
  for (var i = 0; i < ps.length; i++) {
    var t = (ps[i].textContent || '').toLowerCase();
    if (t.indexOf(CFG.HEADING_MATCH) === -1) continue;
    set(ps[i], {
      'font-family': T.serif, 'color': '#0E1F4D',
      'font-size': isMobile() ? CFG.HEADING_SIZE.m : CFG.HEADING_SIZE.d,
      'font-weight': '600', 'letter-spacing': '0px', 'line-height': '100%',
      'text-align': 'center', 'margin': '0px 0px 6px'
    });
    return;
  }
}

  function styleTiles(r) {
    var tiles = r.querySelectorAll('.wht-event-tile-parent-scroll');
    for (var i = 0; i < tiles.length; i++) {
      set(tiles[i], {
        'border-radius': CFG.TILE_RADIUS,
        'box-shadow': '0 6px 20px rgba(18,31,74,.10)'
      });
    }
  }

  function styleInfo(r) {
    var infos = r.querySelectorAll('.wht-prod-info');
    for (var i = 0; i < infos.length; i++) {
      var info = infos[i];
      set(info, { 'padding': '12px 2px 4px', 'gap': '10px', 'align-items': 'flex-start' });

      /* product title — the first <p> in the block */
      /* product title — the first <p> in the block */
      var title = info.querySelector('p');
      if (isMobile()) {
        set(title, {
          'color': '#0E1F4D',
          'font-size': '15px',
          'line-height': '26.26px',
          'font-family': 'inherit',
          'overflow': 'hidden',
          'text-overflow': 'ellipsis',
          'font-weight': '400',
          '-webkit-line-clamp': '2'
        });
      } else {
        set(title, {
          'font-size': '20px',
          'line-height': '26.26px',
          'letter-spacing': '0px',
          'color': '#0E1F4D',
          'font-family': '"Helvetica Neue"',
          'text-overflow': 'ellipsis',
          'font-weight': '500',
          'overflow': 'hidden',
          '-webkit-line-clamp': '2'
        });
      }

      /* store-added SKU line */
      var det = info.querySelector('.deodap-whatmore-details');
      set(det, { 'color': T.gray, 'font-size': '11.5px', 'line-height': '1.4' });

      var sku = info.querySelector('.deodap-whatmore-sku');
      set(sku, {
        'color': '#0E1F4D99',
        'display': 'inline-block',
        'font-size': '11px',
        'font-weight': '500',
        'line-height': '13.75px',
        'max-width': '100%',
        'word-break': 'break-word',
        'letter-spacing': '0px'
      });

      /* price text: any node whose text carries a currency mark */
      var nodes = info.querySelectorAll('div, span, p, s, del');
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n.children.length) continue;                       // leaf nodes only
        var txt = (n.textContent || '').trim();
        if (!/[₹]|Rs\.?/i.test(txt)) continue;
        var struck = /LINE-THROUGH/i.test(getComputedStyle(n).textDecorationLine) ||
                     n.tagName === 'S' || n.tagName === 'DEL';
        if (struck) set(n, { 'color': T.gray, 'font-size': '14px', 'font-weight': '400', 'font-family': "'Inter', sans-serif" });
        else        set(n, { 'font-weight': '700',
      'color': '#000000',
      'font-size': isMobile() ? '15px' : '20px',
      'overflow': 'hidden',
      'text-align': 'left',
      'width': 'auto',
      'line-height': '32.83px',
      'font-family': "'Inter', sans-serif"
    });
      }

      /* the % off badge — Whatmore paints it solid red */
      /* the % off badge — Whatmore paints it solid red */
      if (CFG.BADGE_STYLE !== 'keep') {
        var all = info.querySelectorAll('div');
        for (var k = 0; k < all.length; k++) {
          var elDiv = all[k];
          var bg = getComputedStyle(elDiv).backgroundColor;
          var isBadge = elDiv.getAttribute('data-rk-badge') === '1' ||
                        bg === 'rgb(236, 26, 35)' || bg === 'rgb(220, 38, 38)';
          if (!isBadge) continue;
          elDiv.setAttribute('data-rk-badge', '1');

          if (CFG.BADGE_STYLE === 'gold') {
            set(elDiv, { 'background-color': '#F3E7C6', 'border-radius': '999px', 'padding': '4px 10px' });
            var g = elDiv.querySelector('*') || elDiv;
            set(g, { 'color': T.gold, 'font-size': '11px', 'font-weight': '700' });
          } else {
            set(elDiv, { 'background-color': '#E1F4EA', 'border-radius': '7px', 'padding': '4px 9px' });
            var e = elDiv.querySelector('*') || elDiv;
            set(e, { 'color': '#1E9E5B', 'font-size': '12px', 'font-weight': '700' });
          }
        }
      }
    }
  }

  function apply() {
    var r = root();
    if (!r) return;
    var host = r.closest('.shopify-section') || r.closest('.whatmore-base');
    if (host && !host.classList.contains('rk-pdp-wht')) host.classList.add('rk-pdp-wht');
    styleHeading(r);
    styleTiles(r);
    styleInfo(r);
  }

  apply();

  if (!window._rkWhtResize) {
    window._rkWhtResize = true;
    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 200); });
  }

  if (window._crowai_obs_rkpdp_wht) window._crowai_obs_rkpdp_wht.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_wht = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var obsRoot = document.querySelector('.whatmore-base') ||
                document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_wht.observe(obsRoot, { childList: true, subtree: true });
}
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiPdpWhatmore();
  else document.addEventListener("DOMContentLoaded", executeRakhiPdpWhatmore);
})();
// ===== New PDP <Experience The Similar Products — Whatmore> End =====



// ===== New PDP <Customers Also Bought — PLP card design> Start =====
function executeRakhiPdpAlsoBought() {

  /* ---------------- EDITABLE CONFIG ---------------- */
  var CFG = {
    HEADING: 'Customers also bought',  // '' = keep the theme's own wording
    SHOW_BEST_SELLER: true             // false = hide the teal "Best Seller" ribbon here
  };
  /* ------------------------------------------------- */

  /* anchor on the grid's own class, never the template id */
  function grid() {
    return document.querySelector('ul.related-fea-collection') ||
           document.querySelector('#product--grid.grid.product-grid');
  }

  function section() {
    var g = grid();
    if (!g) return null;
    return g.closest('.shopify-section') || g.parentNode;
  }

  function cards(g) { return g.querySelectorAll(':scope > li'); }

  /* the one line that makes your PLP code adopt these cards */
  function tag(li) {
    var card = li.querySelector('.card') || li.querySelector('.card-wrapper');
    if (card && !card.classList.contains('card-coll-new')) card.classList.add('card-coll-new');
    return card;
  }

  function ensureBadge(card) {
    if (!card || card.querySelector('.discount-badge')) return;
    var inner = card.querySelector('.card__inner');
    if (!inner) return;

    var pct = '';
    var ov = card.parentNode && card.parentNode.querySelector('.custom-discount-overlay');
    if (!ov) ov = card.querySelector('.custom-discount-overlay');
    if (ov) { var m = ov.textContent.match(/(\d+)/); if (m) pct = m[1]; }

    if (!pct) {
      var num = function (el) {
        if (!el) return 0;
        var t = String(el.textContent).replace(/[^\d.]/g, '');
        return parseFloat(t) || 0;
      };
      var sp = num(card.querySelector('.sale-price, .price-item--sale'));
      var cp = num(card.querySelector('.compare-price s, .compare-price, .price-item--regular'));
      if (sp > 0 && cp > sp) pct = String(Math.round((1 - sp / cp) * 100));
    }
    if (!pct) return;

    var b = document.createElement('span');
    b.className = 'discount-badge';
    b.textContent = pct + '% OFF';
    inner.insertBefore(b, inner.firstChild);
  }

  function fixOrder(card) {
    if (!card) return;
    var divider = card.querySelector('.cp-card-divider');
    var atc = card.querySelector('.product-card-buttons.new-atc');
    if (!divider || !atc || !divider.parentNode) return;
    if (divider.nextElementSibling !== atc) {
      divider.parentNode.insertBefore(atc, divider.nextSibling);
    }
  }

  function releaseHeading(sec) {
    var t = sec.querySelector('.custom-collection-title, .collection__title');
    if (!t || !t.getAttribute('style')) return;
    ['font-family', 'color', 'font-weight', 'padding', 'text-align',
     'text-transform', 'line-height', 'letter-spacing', 'font-size']
      .forEach(function (p) { t.style.removeProperty(p); });
    if (!t.getAttribute('style')) t.removeAttribute('style');
  }

  function apply() {
    var g = grid();
    if (!g) return;
    var sec = section();
    if (!sec) return;

    if (!sec.classList.contains('rk-pdp-ab')) sec.classList.add('rk-pdp-ab');
    sec.classList.toggle('rk-ab-no-bs', !CFG.SHOW_BEST_SELLER);

    releaseHeading(sec);

    if (CFG.HEADING) {
      var h = sec.querySelector('.custom-title');
      if (h && h.textContent.trim() !== CFG.HEADING) h.textContent = CFG.HEADING;
    }

    var list = cards(g);
    for (var i = 0; i < list.length; i++) {
      var card = tag(list[i]);
      ensureBadge(card);
      fixOrder(card);
    }
  }

  apply();

  if (window._crowai_obs_rkpdp_ab) window._crowai_obs_rkpdp_ab.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_ab = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var obsRoot = document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_ab.observe(obsRoot, { childList: true, subtree: true });
}
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiPdpAlsoBought();
  else document.addEventListener("DOMContentLoaded", executeRakhiPdpAlsoBought);
})();
// ===== New PDP <Customers Also Bought — PLP card design> End =====




// ===== New PDP <Recently Viewed — PLP card design> Start =====
function executeRakhiPdpRecent() {

  /* ---------------- EDITABLE CONFIG ---------------- */
  var CFG = {
    HEADING:        'Recently Viewed',  // '' = keep the theme's "Recently Viewed Products"
    MAX:            10,                 // most-recent N to show
    SHOW_CLEAR_ALL: false,              // Figma has no "Clear All" — true brings it back
    SHOW_REMOVE:    false,              // Figma has no per-card ×    — true brings it back
    HIDE_SELF:      true,               // don't show the product you're currently on
    HIDE_SOLD_OUT:  true,
    MONEY:          'Rs. '
  };
  /* ------------------------------------------------- */

  window._rkRvCache = window._rkRvCache || {};

  function wrapper() { return document.querySelector('.pdp-viewed-wrapper'); }

  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    return CFG.MONEY + (Number(cents) / 100).toFixed(2);
  }
  function thumb(url, px) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + px + 'x' + px + '_crop_center$1$2');
  }
  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1].toLowerCase() : '';
  }

  /* the theme already rendered one <a> per viewed product — read the handles off it */
  function handles(wrap) {
    var out = [], seen = {};
    var links = wrap.querySelectorAll('.pdp-viewed-item a[href*="/products/"]');
    var here = currentHandle();
    for (var i = 0; i < links.length; i++) {
      var m = (links[i].getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) continue;
      var h = m[1].toLowerCase();
      if (seen[h]) continue;
      if (CFG.HIDE_SELF && h === here) continue;
      seen[h] = 1;
      out.push(h);
      if (out.length >= CFG.MAX) break;
    }
    return out;
  }

  function fetchProduct(handle) {
    if (window._rkRvCache[handle]) return Promise.resolve(window._rkRvCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { window._rkRvCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  var EYE = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>';

  function cardHTML(p, v) {
    var url = '/products/' + p.handle + '?variant=' + v.id;
    var pct = (v.compare_at_price && v.compare_at_price > v.price)
      ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
    var cmp = pct ? '<span class="compare-price">MRP <s>' + money(v.compare_at_price) + '</s></span>' : '';
    var badge = pct ? '<span class="discount-badge">' + pct + '% OFF</span>' : '';

    return '<li class="grid__item rk-rv-item">' +
      '<div class="card card--standard card--media card-coll-new" style="--ratio-percent:100%;">' +
        '<div class="Quick-veiew-icon"><div class="product-card-quick-view-button">' +
          '<a class="rk-rv-eye" href="' + url + '" aria-label="View ' + p.title + '">' + EYE + '</a>' +
        '</div></div>' +
        '<div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent:100%;">' +
          badge +
          '<a class="rk-rv-media" href="' + url + '">' +
            '<img src="' + thumb(p.featured_image, 400) + '" alt="" loading="lazy" width="300" height="300">' +
          '</a>' +
        '</div>' +
        '<div class="card__content"><div class="card__information">' +
          '<div class="card_info-top"><div class="pdp-price-badge-alignment"><div class="price__container">' +
            '<div class="price__sale"><span class="sale-price">' + money(v.price) + '</span>' + cmp + '</div>' +
          '</div></div></div>' +
          '<h2 class="card__heading h5"><a class="full-unstyled-link" href="' + url + '">' + p.title + '</a></h2>' +
        '</div></div>' +
        '<div class="product-card-buttons new-atc">' +
          '<form action="/cart/add" method="post">' +
            '<input type="hidden" name="id" value="' + v.id + '" class="product-variant-id">' +
            '<button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary">ADD TO CART</button>' +
          '</form>' +
        '</div>' +
        '<div class="quick-add no-js-hidden"></div>' +
      '</div>' +
    '</li>';
  }

  /* the ATC must sit directly after the lotus divider, exactly like the PLP */
  function fixOrder(grid) {
    var cards = grid.querySelectorAll('.card-coll-new');
    for (var i = 0; i < cards.length; i++) {
      var d = cards[i].querySelector('.cp-card-divider');
      var a = cards[i].querySelector('.product-card-buttons.new-atc');
      if (d && a && d.parentNode && d.nextElementSibling !== a) {
        d.parentNode.insertBefore(a, d.nextSibling);
      }
    }
  }

  function setHidden(wrap, hide) {
    var sec = wrap.closest('.shopify-section') || wrap;
    if (hide) {
      if (sec.style.display !== 'none') sec.style.setProperty('display', 'none', 'important');
    } else if (sec.style.display === 'none') {
      sec.style.removeProperty('display');
      if (!sec.getAttribute('style')) sec.removeAttribute('style');
    }
  }

  function build(wrap) {
    var list = handles(wrap);
    var grid = document.getElementById('rk-rv-grid');

    if (!list.length) {                       // nothing viewed yet -> hide
      setHidden(wrap, true);
      return;
    }

    var key = list.join(',');
    if (grid && grid.getAttribute('data-rk-key') === key && grid.children.length) {
      setHidden(wrap, false);                 // already built for these items
      fixOrder(grid);
      return;
    }

    Promise.all(list.map(fetchProduct)).then(function (products) {
      var html = '';
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        if (!p || !p.variants || !p.variants.length) continue;
        var v = p.variants[0];
        if (CFG.HIDE_SOLD_OUT && v.available === false) continue;
        html += cardHTML(p, v);
      }
      if (!html) return;

      var g = document.getElementById('rk-rv-grid');
      if (!g) {
        g = document.createElement('ul');
        g.id = 'rk-rv-grid';
        g.className = 'rk-rv-grid grid product-grid grid--5-col-desktop grid--2-col-tablet-down';
        g.setAttribute('role', 'list');
        var head = wrap.querySelector('.pdp-viewed-header');
        if (head && head.nextSibling) wrap.insertBefore(g, head.nextSibling);
        else wrap.appendChild(g);
      }
      g.setAttribute('data-rk-key', key);
      g.innerHTML = html;
      fixOrder(g);
      setHidden(wrap, false);                 // cards are in -> reveal the section
    });
  }

  function apply() {
    var wrap = wrapper();
    if (!wrap) return;

    var sec = wrap.closest('.shopify-section') || wrap;
    if (!sec.classList.contains('rk-pdp-rv')) sec.classList.add('rk-pdp-rv');
    sec.classList.toggle('rk-rv-no-clear', !CFG.SHOW_CLEAR_ALL);
    sec.classList.toggle('rk-rv-no-remove', !CFG.SHOW_REMOVE);

    if (CFG.HEADING) {
      var h = wrap.querySelector('.pdp-viewed-title');
      if (h && h.textContent.trim() !== CFG.HEADING) h.textContent = CFG.HEADING;
    }

    build(wrap);
    fixOrder(wrap);
  }

  apply();
  [400, 1200, 2500].forEach(function (ms) { setTimeout(apply, ms); });

  if (window._crowai_obs_rkpdp_rv) window._crowai_obs_rkpdp_rv.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_rv = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var obsRoot = document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_rv.observe(obsRoot, { childList: true, subtree: true });
}
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiPdpRecent();
  else document.addEventListener("DOMContentLoaded", executeRakhiPdpRecent);
})();
// ===== New PDP <Recently Viewed — PLP card design> End =====




// ===== New PDP <Customer Reviews — Judge.me> Start =====
function executeRakhiPdpReviews() {

  /* ---------------- EDITABLE CONFIG ---------------- */
  var CFG = {
    HEADING:    'Customer Reviews',      // '' = leave the theme's wording alone
    MORE_LABEL: 'SEE ALL REVIEWS'      // '' = keep Judge.me's "See All Reviews"
  };
  /* ------------------------------------------------- */

  function widget() { return document.getElementById('judgeme_product_reviews'); }

  function apply() {
    var w = widget();
    if (!w) return;

    var sec = w.closest('.shopify-section') || w;
    if (!sec.classList.contains('rk-pdp-rev')) sec.classList.add('rk-pdp-rev');

    if (CFG.HEADING) {
      var h = w.querySelector('.jdgm-rev-widg__title');
      if (h && h.textContent.trim() !== CFG.HEADING) h.textContent = CFG.HEADING;
    }

    if (CFG.MORE_LABEL) {
      var link = w.querySelector('.see-all-reviews-link');
      if (link && link.textContent.trim() !== CFG.MORE_LABEL) link.textContent = CFG.MORE_LABEL;
    }
  }

  apply();
  /* Judge.me's review_widget.js hydrates late — re-assert a few times */
  [300, 900, 2000].forEach(function (ms) { setTimeout(apply, ms); });

  if (window._crowai_obs_rkpdp_rev) window._crowai_obs_rkpdp_rev.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_rev = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var root = widget() || document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_rev.observe(root, { childList: true, subtree: true });
}
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiPdpReviews();
  else document.addEventListener("DOMContentLoaded", executeRakhiPdpReviews);
})();
// ===== New PDP <Customer Reviews — Judge.me> End =====








// ===== New PDP <Card behaviour — ported from the PLP campaign> Start =====
const rkPdpCardRedesign = () => {

    /* dividers — UNCHANGED */
    function injectDividers() {
        document.querySelectorAll('.grid.product-grid > li .card-coll-new').forEach(card => {
            if (card.querySelector('.cp-card-divider')) return;
            const quickAdd = card.querySelector('.quick-add');
            if (!quickAdd) return;
            const divider = document.createElement('div');
            divider.className = 'cp-card-divider';
            divider.innerHTML = '<span class="cp-card-divider__line" style="background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #C9A227 100%);"></span><span class="cp-card-divider__chevron"><svg class="cp-card-divider__lotus" viewBox="0 0 43.85 28.16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M 19.55,1.32 C 18.65,2.72 17.85,6.02 17.85,8.62 C 17.65,13.42 17.65,13.42 13.85,9.72 C 10.15,6.12 2.35,2.32 0.25,3.02 C -0.35,3.32 0.15,5.72 1.65,9.22 C 9.95,29.62 24.85,34.22 36.25,19.72 C 39.35,15.82 44.55,4.72 43.65,3.32 C 42.95,2.22 35.05,5.82 31.05,9.42 C 26.65,13.42 26.65,13.42 26.55,8.62 C 26.45,4.62 24.25,0.02 22.05,0.02 C 21.35,0.02 20.25,0.62 19.55,1.32 Z" fill="#C4A052"/></svg></span><span class="cp-card-divider__line" style="background: linear-gradient(90deg, #C9A227 0%, rgba(0, 0, 0, 0) 100%);"></span>';
            quickAdd.parentNode.insertBefore(divider, quickAdd);
        });
    }

    /* FIX C1 + C2: move badge onto the image, reformat to -NN% */
    function fixDiscountBadges() {
        document.querySelectorAll('.grid.product-grid > li .card-coll-new').forEach(card => {
            const badge = card.querySelector('.discount-badge');
            if (!badge) return;
            const inner = card.querySelector('.card__inner') || card;
            if (badge.parentNode !== inner) { inner.insertBefore(badge, inner.firstChild); }
            if (!badge.dataset.cpFormatted) {
                const m = badge.textContent.match(/(\d+)/);
                if (m) { badge.textContent = '-' + m[1] + '%'; badge.dataset.cpFormatted = '1'; }
            }
        });
    }

    /* FIX C5: hanging rakhi ornament (injected element, not pseudo) */
    function injectOrnaments() {
        document.querySelectorAll('.grid.product-grid > li .card-coll-new').forEach(card => {
            const inner = card.querySelector('.card__inner') || card;
            if (inner.querySelector('.cp-rakhi-ornament')) return;
            if (getComputedStyle(inner).position === 'static') { inner.style.position = 'relative'; }
            const orn = document.createElement('span');
            orn.className = 'cp-rakhi-ornament';
            inner.appendChild(orn);
        });
    }

    function applyChanges() {
        fixDiscountBadges();
        injectOrnaments();
        injectDividers();
        
    }

    applyChanges();
    if (window._crowai_obs_rkpdp_cardredesign) window._crowai_obs_rkpdp_cardredesign.disconnect();
    let applied = false; let rafId = null;
    window._crowai_obs_rkpdp_cardredesign = new MutationObserver(() => {
        const grid = document.querySelector('.grid.product-grid');
        if (grid) {
            if (!applied) { applied = true; applyChanges(); }
            else { if (rafId) cancelAnimationFrame(rafId); rafId = requestAnimationFrame(applyChanges); }
        }
    });
    const obsRoot = document.querySelector('main') || document.body;
    window._crowai_obs_rkpdp_cardredesign.observe(obsRoot, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
};
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") rkPdpCardRedesign();
  else document.addEventListener("DOMContentLoaded", rkPdpCardRedesign);
})();


const rkPdpMoveAtcOut = () => {
    function moveAtc() {
        document.querySelectorAll('.grid.product-grid .quick-add.no-js-hidden').forEach(function (quickAdd) {
            const atc = quickAdd.querySelector('.product-card-buttons.new-atc');
            if (atc && quickAdd.contains(atc)) {
                /* move it out to sit right before the quick-add (i.e. after the divider) */
                quickAdd.parentNode.insertBefore(atc, quickAdd);
            }
        });
    }

    moveAtc();

    if (window._crowai_obs_rkpdp_moveatc) window._crowai_obs_rkpdp_moveatc.disconnect();
    let rafId = null;
    window._crowai_obs_rkpdp_moveatc = new MutationObserver(() => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(moveAtc);
    });
    const obsRoot = document.querySelector('main') || document.body;
    window._crowai_obs_rkpdp_moveatc.observe(obsRoot, { childList: true, subtree: true });
};
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") rkPdpMoveAtcOut();
  else document.addEventListener("DOMContentLoaded", rkPdpMoveAtcOut);
})();


const rkPdpCardQtyStepper = () => {
  const CART_ADD='/cart/add.js', CART_CHANGE='/cart/change.js', CART_JS='/cart.js';
  const CARD_SEL='.grid.product-grid > li .card-coll-new';
  const SECTIONS='cart-drawer,cart-icon-bubble';
  let cartMap={}, cartLoaded=false;

  function drawer(){ return document.querySelector('cart-drawer'); }
  function renderDrawer(json){ const d=drawer(); try{ if(d && d.renderContents) d.renderContents(json); }catch(e){} }
  function openDrawer(){ const d=drawer(); try{ if(d){ if(d.classList) d.classList.remove('is-empty'); if(d.open) d.open(); } }catch(e){} }

  function getForm(card){ return card.querySelector('.product-card-buttons.new-atc form') || card.querySelector('form[action*="/cart/add"]'); }
  function getVariant(card){ const f=getForm(card); const i=f&&f.querySelector('input[name="id"]'); return i?String(i.value):null; }
  function getAtcWrap(card){ return card.querySelector('.product-card-buttons.new-atc'); }

  function cardQty(card){
    const v=getVariant(card); if(!v) return 0;
    const confirmed=cartMap[v]||0, optimistic=parseInt(card.getAttribute('data-cp-qty')||'0',10)||0;
    if (cartLoaded) return confirmed>0 ? confirmed : (card._cpPending ? optimistic : 0);
    return Math.max(confirmed, optimistic);
  }
    function ensureStepper(card){
    let st=card.querySelector('.cp-qty'); const atc=getAtcWrap(card);
    if(!st){ st=document.createElement('div'); st.className='cp-qty';
      st.innerHTML='<button type="button" class="cp-qty__btn cp-qty__minus" aria-label="Decrease quantity">&minus;</button>'+
        '<input class="cp-qty__count" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="2" value="1" data-qty="1" aria-label="Quantity">'+
        '<button type="button" class="cp-qty__btn cp-qty__plus" aria-label="Increase quantity">+</button>'; }
    if(atc && atc.parentNode && atc.nextSibling!==st){ atc.parentNode.insertBefore(st, atc.nextSibling); }
    else if((!atc || !atc.parentNode) && st.parentNode!==card){ card.appendChild(st); }
    return st;
  }
  function setBusy(card,on){ const st=card.querySelector('.cp-qty'); if(st) st.classList.toggle('cp-busy', !!on); }
  function render(card){
    const v=getVariant(card); if(!v)return;
    const qty=cardQty(card);
    if(qty>0){ card.classList.add('cp-in-cart'); card.setAttribute('data-cp-qty',qty);
      const st=ensureStepper(card); const c=st.querySelector('.cp-qty__count');
      if(c && document.activeElement!==c){ c.dataset.qty=qty; if(c.value!==String(qty)) c.value=qty; }   /* ← changed */
    }
    else { card.classList.remove('cp-in-cart'); card.removeAttribute('data-cp-qty'); card._cpPending=false; const st=card.querySelector('.cp-qty'); if(st)st.remove(); }
  }
  function renderAll(){ document.querySelectorAll(CARD_SEL).forEach(render); }
  function updateMap(cart){ cartMap={}; ((cart&&cart.items)||[]).forEach(it=>{cartMap[String(it.variant_id)]=it.quantity;}); cartLoaded=true; }
  function refreshCart(){ return fetch(CART_JS,{headers:{'Accept':'application/json'}}).then(r=>r.json()).then(c=>{updateMap(c);
      document.querySelectorAll(CARD_SEL).forEach(card=>{ const v=getVariant(card); if(v && (cartMap[v]||0)>0) card._cpPending=false; });
      renderAll();return c;}).catch(()=>{}); }
      window.rkPdpRefreshCartQty = refreshCart;

  function addOne(card,v){
    setBusy(card,true);
    return fetch(CART_ADD,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({ items:[{id:Number(v),quantity:1}], sections:SECTIONS, sections_url:location.pathname })})
      .then(r=>r.json().then(d=>({ok:r.ok,data:d})))
      .then(res=>{ if(!res.ok){ console.error('add failed',res.data); return; }
        renderDrawer(res.data); openDrawer();
        card._cpPending=true; card.setAttribute('data-cp-qty',(cardQty(card)||0)+1); render(card);
        return refreshCart();
      })
      .catch(e=>console.error('add error',e))
      .then(()=> setBusy(card,false));
  }
  function changeQty(card,v,q){
    q=Math.max(0,q); setBusy(card,true);
    return fetch(CART_CHANGE,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({ id:String(v), quantity:q, sections:SECTIONS, sections_url:location.pathname })})
      .then(r=>r.json().then(d=>({ok:r.ok,data:d})))
      .then(res=>{ if(!res.ok){ console.error('change failed',res.data); return; }
        updateMap(res.data); renderDrawer(res.data);
        if(q<=0){ card._cpPending=false; } else { card._cpPending=true; card.setAttribute('data-cp-qty',q); }
        renderAll();
      })
      .catch(e=>console.error('change error',e))
      .then(()=> setBusy(card,false));
  }

  if(!window._cpQtyDelegated){
    window._cpQtyDelegated=true;
    document.addEventListener('click', function(e){
      /* never intercept clicks inside the quick-view modal — its own
         <product-form> handles add-to-cart for the previewed product */
      if(e.target.closest && e.target.closest('quick-add-modal, .quick-add-modal')) return;
      const step=e.target.closest && e.target.closest('.cp-qty__plus, .cp-qty__minus');
      if(step){
        const card=step.closest('.card-coll-new'); if(!card)return;
        const v=getVariant(card); if(!v)return;
        e.preventDefault(); e.stopPropagation();
        if(card.querySelector('.cp-qty.cp-busy')) return;
        const cur=cardQty(card);
                changeQty(card, v, step.classList.contains('cp-qty__plus') ? Math.min(99, cur+1) : cur-1);
        return;
      }
      const sub=e.target.closest && e.target.closest('.card-coll-new .quick-add__submit');
      if(sub){
        /* quick-view (and wishlist) buttons reuse the .quick-add__submit class —
           let their own handlers run instead of treating the click as ATC */
        if(sub.closest('.Quick-veiew-icon, .product-card-quick-view-button, .quick-view, .custom-wish')) return;
        const card=sub.closest('.card-coll-new'); if(!card)return;
        const v=getVariant(card); if(!v)return;
        e.preventDefault(); e.stopPropagation();
        if(card.querySelector('.cp-qty.cp-busy')) return;
        addOne(card, v);
      }
    }, true);

        const MAX_QTY = 99;

    /* stop the card's own click handlers when tapping the number */
    document.addEventListener('click', function(e){
      if(e.target.classList && e.target.classList.contains('cp-qty__count')) e.stopPropagation();
    }, true);

    document.addEventListener('focusin', function(e){
      if(e.target.classList && e.target.classList.contains('cp-qty__count')) e.target.select();
    });

    document.addEventListener('input', function(e){
      const el=e.target; if(!el.classList || !el.classList.contains('cp-qty__count')) return;
      let v=el.value.replace(/[^0-9]/g,'').slice(0,2);
      if(Number(v)>MAX_QTY) v=String(MAX_QTY);
      el.value=v;
    });

    document.addEventListener('keydown', function(e){
      const el=e.target; if(!el.classList || !el.classList.contains('cp-qty__count')) return;
      if(e.key==='Enter'){ e.preventDefault(); el.blur(); }
      if(e.key==='Escape'){ el.value=el.dataset.qty||'1'; el.blur(); }
    });

    /* focusout bubbles (blur does not) — commit here */
    document.addEventListener('focusout', function(e){
      const el=e.target; if(!el.classList || !el.classList.contains('cp-qty__count')) return;
      const card=el.closest('.card-coll-new'); if(!card) return;
      const vid=getVariant(card); if(!vid) return;
      const cur=parseInt(el.dataset.qty,10)||0;
      let q=parseInt(el.value,10);
      if(isNaN(q)){ el.value=cur; return; }
      q=Math.max(0,Math.min(MAX_QTY,q));
      if(q===cur){ el.value=cur; return; }
      if(card.querySelector('.cp-qty.cp-busy')){ el.value=cur; return; }
      changeQty(card, vid, q);
    });
  }

  refreshCart();
  if(window._crowai_obs_rkpdp_cardqty) window._crowai_obs_rkpdp_cardqty.disconnect();
  let raf=null;
  window._crowai_obs_rkpdp_cardqty=new MutationObserver(()=>{ if(raf)cancelAnimationFrame(raf); raf=requestAnimationFrame(renderAll); });
  const root=document.querySelector('main')||document.body;
  window._crowai_obs_rkpdp_cardqty.observe(root,{childList:true,subtree:true});
};
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") rkPdpCardQtyStepper();
  else document.addEventListener("DOMContentLoaded", rkPdpCardQtyStepper);
})();


// ===== New PDP <Card behaviour — ported from the PLP campaign> End =====



// ===== New PDP <Breadcrumb — ported from the PLP campaign> Start =====
const rkPdpBreadcrumb = () => {
    function applyChanges() {
        const breadcrumbList = document.querySelector('nav[aria-label="Breadcrumb"] .breadcrumbs__list');
        if (!breadcrumbList) return;
        if (document.getElementById('crowai-rakhi-breadcrumb')) return;

        const lastItem = breadcrumbList.querySelector('.breadcrumbs__item[aria-current="page"]');
        if (!lastItem) return;

        const rakhiItem = document.createElement('li');
        rakhiItem.className = 'breadcrumbs__item';
        rakhiItem.id = 'crowai-rakhi-breadcrumb';

        const rakhiLink = document.createElement('a');
        rakhiLink.className = 'breadcrumbs__link';
        rakhiLink.href = '/collections/rakhi-2';
        rakhiLink.textContent = 'Rakhi Collection';

        rakhiItem.appendChild(rakhiLink);
        breadcrumbList.insertBefore(rakhiItem, lastItem);

    }

    applyChanges();

    if (window._crowai_obs_rkpdp_breadcrumb) window._crowai_obs_rkpdp_breadcrumb.disconnect();
    let applied = false;
    let rafId = null;
    window._crowai_obs_rkpdp_breadcrumb = new MutationObserver(() => {
        const breadcrumbList = document.querySelector('nav[aria-label="Breadcrumb"] .breadcrumbs__list');
        const alreadyApplied = document.getElementById('crowai-rakhi-breadcrumb');
        if (breadcrumbList && !alreadyApplied) {
            if (!applied) { applied = true; applyChanges(); }
            else { if (rafId) cancelAnimationFrame(rafId); rafId = requestAnimationFrame(applyChanges); }
        }
    });
    const obsRoot = document.querySelector('main') || document.body;
    window._crowai_obs_rkpdp_breadcrumb.observe(obsRoot, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
};
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") rkPdpBreadcrumb();
  else document.addEventListener("DOMContentLoaded", rkPdpBreadcrumb);
})();
// ===== New PDP <Breadcrumb — ported from the PLP campaign> End =====




// // ===== New PDP <Sticky Bar — Add to Cart to Buy Now> Start =====
// function executeRakhiStickyBuyNow() {

//   var CFG = {
//     LABEL: 'Buy Now',
//     BTN_SEL: '[id^="crowai-v2-atc-btn-"], [id^="crowai-v2-dt-atc-btn-"]',
//     GOKWIK_SEL: '#gokwik-buy-now, .custom-buy-btn'
//   };

//   function getRealBuyBtn() {
//     var btn = document.querySelector(CFG.GOKWIK_SEL);
//     if (!btn) return null;
//     var cs = window.getComputedStyle(btn);
//     if (cs.display === 'none' || cs.visibility === 'hidden') return null;
//     return btn;
//   }

//   var busy = false;
//   function buyNow() {
//     if (busy) return;
//     var real = getRealBuyBtn();
//     if (!real) return;
//     busy = true;
//     real.click();
//     setTimeout(function () { busy = false; }, 800);
//   }

//   function relabel(btn) {
//     if (btn.getAttribute('data-rk-buynow') === '1') return;
//     btn.setAttribute('data-rk-buynow', '1');
//     if (btn.textContent.trim() !== CFG.LABEL) btn.textContent = CFG.LABEL;
//   }

//   function apply() {
//     var btns = document.querySelectorAll(CFG.BTN_SEL);
//     for (var i = 0; i < btns.length; i++) relabel(btns[i]);
//   }

//   apply();
//   [60, 300, 1200].forEach(function (ms) { setTimeout(apply, ms); });

//   if (!window._rkStickyBuyNowDelegated) {
//     window._rkStickyBuyNowDelegated = true;
//     document.addEventListener('click', function (e) {
//       var btn = e.target && e.target.closest && e.target.closest(CFG.BTN_SEL);
//       if (!btn) return;
//       e.preventDefault();
//       e.stopImmediatePropagation();
//       buyNow();
//     }, true);
//   }

//   if (window._crowai_obs_rkpdp_stickybuynow) window._crowai_obs_rkpdp_stickybuynow.disconnect();
//   var raf = null;
//   window._crowai_obs_rkpdp_stickybuynow = new MutationObserver(function () {
//     if (raf) cancelAnimationFrame(raf);
//     raf = requestAnimationFrame(apply);
//   });
//   var root = document.querySelector('#MainContent') || document.body;
//   window._crowai_obs_rkpdp_stickybuynow.observe(root, { childList: true, subtree: true });
// }
// /* run ONLY on rakhi / raksha product pages */
// (function () {
//   var p = location.pathname.replace(/\/$/, "").toLowerCase();
//   if (!window.__rkIsRakhiPdp(p)) return;
//   if (document.readyState !== "loading") executeRakhiStickyBuyNow();
//   else document.addEventListener("DOMContentLoaded", executeRakhiStickyBuyNow);
// })();
// // ===== New PDP <Sticky Bar — Add to Cart to Buy Now> End =====

// ===== New PDP <Sticky Bar — Add to Cart + Buy Now> Start =====
function executeRakhiStickyBuyNow() {

  var CFG = {
    LABEL: 'Buy Now',
    // match BOTH mobile + desktop ATC buttons from the sticky bar snippet
    ATC_SEL: '[id^="crowai-v2-atc-btn-"], [id^="crowai-v2-dt-atc-btn-"]',
    GOKWIK_SEL: '#gokwik-buy-now, .custom-buy-btn'
  };

  function getRealBuyBtn() {
    var btn = document.querySelector(CFG.GOKWIK_SEL);
    if (!btn) return null;
    var cs = window.getComputedStyle(btn);
    if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    return btn;
  }

  var busy = false;
  function buyNow() {
    if (busy) return;
    var real = getRealBuyBtn();
    if (!real) return;
    busy = true;
    real.click();
    setTimeout(function () { busy = false; }, 800);
  }

  function injectStyles() {
    if (document.getElementById('rk-sticky-buynow-style')) return;
    var css =
      /* override the base Add to Cart color — Rakhi PDP only */
      'html.rk-pdp-on [id^="crowai-v2-atc-btn-"],' +
      'html.rk-pdp-on [id^="crowai-v2-dt-atc-btn-"]{' +
        'background:#ff0000 !important;' +   /* pick your color */
      '}' +
      '.rk-sticky-buynow-btn{background:#000000;color:#fff;border:none;border-radius:12px;' +
      'font-weight:700;cursor:pointer;letter-spacing:.2px;white-space:nowrap;' +
      'transition:opacity .15s ease;-webkit-tap-highlight-color:transparent;}' +
      '.rk-sticky-buynow-btn:active{opacity:.85}' +
      /* mobile row: ATC + Buy Now split the space evenly */
      '[id^="crowai-v2-inner-"].rk-has-buynow{gap:8px;}' +
      '[id^="crowai-v2-inner-"].rk-has-buynow [id^="crowai-v2-atc-btn-"],' +
      '[id^="crowai-v2-inner-"].rk-has-buynow .rk-sticky-buynow-btn{' +
        'flex:1;max-width:none;padding:12px 8px;font-size:12px;border-radius: 9px;}' +
      /* desktop row: keep ATC as-is, Buy Now sits right after it */
      '[id^="crowai-v2-dt-inner-"].rk-has-buynow .rk-sticky-buynow-btn{' +
        'padding:14px 24px;min-width:250px;font-size:15px;}';
    var style = document.createElement('style');
    style.id = 'rk-sticky-buynow-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function ensureBuyBtn(atcBtn) {
    if (!atcBtn || !atcBtn.parentNode) return;
    var isDesktop = atcBtn.id.indexOf('crowai-v2-dt-atc-btn-') === 0;
    var uidPart = atcBtn.id.replace(isDesktop ? 'crowai-v2-dt-atc-btn-' : 'crowai-v2-atc-btn-', '');
    var newId = (isDesktop ? 'crowai-v2-dt-buynow-btn-' : 'crowai-v2-buynow-btn-') + uidPart;

    if (document.getElementById(newId)) return; // already injected

    var wrap = atcBtn.parentNode;
    wrap.classList.add('rk-has-buynow');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = newId;
    btn.className = 'rk-sticky-buynow-btn';
    btn.setAttribute('data-rk-buynow', '1');
    btn.textContent = CFG.LABEL;

    // sits directly after the existing Add to Cart button
    wrap.insertBefore(btn, atcBtn.nextSibling);
  }

  function apply() {
    injectStyles();
    var atcBtns = document.querySelectorAll(CFG.ATC_SEL);
    for (var i = 0; i < atcBtns.length; i++) ensureBuyBtn(atcBtns[i]);
  }

  apply();
  [60, 300, 1200].forEach(function (ms) { setTimeout(apply, ms); });

  if (!window._rkStickyBuyNowDelegated) {
    window._rkStickyBuyNowDelegated = true;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.rk-sticky-buynow-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      buyNow();
    }, true);
  }

  if (window._crowai_obs_rkpdp_stickybuynow) window._crowai_obs_rkpdp_stickybuynow.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_stickybuynow = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var root = document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_stickybuynow.observe(root, { childList: true, subtree: true });
}
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiStickyBuyNow();
  else document.addEventListener("DOMContentLoaded", executeRakhiStickyBuyNow);
})();
// ===== New PDP <Sticky Bar — Add to Cart + Buy Now> End =====

function executeRakhiPdpRequiredProps() {

  /* ---------------- EDITABLE CONFIG ---------------- */
  var CFG = {
    /* [] = require EVERY visible line-item property field on the product form.
       To require only specific ones, list the exact property names as they
       appear in the input's name="properties[…]", e.g.
         REQUIRE_ONLY: ['Customization Text (7 Chr)'] */
    REQUIRE_ONLY: [],

    MSG: 'Please enter your customisation text before you continue.',

    /* controls that start a purchase for THIS product */
    BUY_SEL: [
      'product-info .product-form__submit',
      'product-info button[name="add"]',
      '#gokwik-buy-now',
      '.custom-buy-btn',
      '[id^="crowai-v2-atc-btn-"]',
      '[id^="crowai-v2-dt-atc-btn-"]',
      '.rk-sticky-buynow-btn'
    ].join(','),

    /* never guard clicks that came from these — other products */
    SKIP_SEL: 'quick-add-modal, .quick-add-modal, .card-coll-new, #rk-pdp-addons, .grid.product-grid'
  };
  /* ------------------------------------------------- */

  function form() {
    return document.querySelector('product-info product-form form[action*="/cart/add"]') ||
           document.querySelector('product-info form[action*="/cart/add"]');
  }

  function visible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function propName(el) {
    var m = (el.name || '').match(/^properties\[(.*)\]$/);
    return m ? m[1] : '';
  }

  function fields() {
    var f = form();
    if (!f) return [];
    var out = [];
    var list = f.querySelectorAll(
      'input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'
    );
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      /* checkboxes / radios are opt-ins, not text entry — leave them alone */
      if (el.type === 'hidden' || el.type === 'checkbox' || el.type === 'radio') continue;
      /* properties[_foo] are app-written hidden values */
      if (/^properties\[_/.test(el.name)) continue;
      if (el.closest(CFG.SKIP_SEL)) continue;
      if (!visible(el)) continue;
      if (CFG.REQUIRE_ONLY.length && CFG.REQUIRE_ONLY.indexOf(propName(el)) === -1) continue;
      out.push(el);
    }
    return out;
  }

  function firstEmpty() {
    var list = fields();
    for (var i = 0; i < list.length; i++) {
      if (!String(list[i].value || '').trim()) return list[i];
    }
    return null;
  }

  function msgFor(el) {
    var m = el.nextElementSibling;
    if (m && m.classList && m.classList.contains('rk-req-msg')) return m;
    m = document.createElement('div');
    m.className = 'rk-req-msg';
    m.setAttribute('role', 'alert');
    el.parentNode.insertBefore(m, el.nextSibling);
    return m;
  }

  function showError(el) {
    el.classList.add('rk-req-invalid');
    el.setAttribute('aria-invalid', 'true');
    var m = msgFor(el);
    if (m.textContent !== CFG.MSG) m.textContent = CFG.MSG;
    m.classList.add('is-on');
    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.focus({ preventScroll: true });
    } catch (e) { el.focus(); }
  }

  function clearError(el) {
    el.classList.remove('rk-req-invalid');
    el.removeAttribute('aria-invalid');
    var m = el.nextElementSibling;
    if (m && m.classList && m.classList.contains('rk-req-msg')) m.classList.remove('is-on');
  }

  /* true = allowed to proceed */
  function guard() {
    var bad = firstEmpty();
    if (!bad) return true;
    showError(bad);
    return false;
  }

  function injectStyles() {
    if (document.getElementById('rk-req-props-style')) return;
    var s = document.createElement('style');
    s.id = 'rk-req-props-style';
    s.textContent =
      '.rk-req-invalid{border-color:#E11D2A !important;box-shadow:0 0 0 3px rgba(225,29,42,.12) !important;}' +
      '.rk-req-msg{display:none;color:#E11D2A;font-size:12px;line-height:1.4;margin:6px 0 0;}' +
      '.rk-req-msg.is-on{display:block;}';
    document.head.appendChild(s);
  }

  function apply() {
    injectStyles();
    var list = fields();
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (!el.hasAttribute('required')) el.setAttribute('required', 'required');
      if (el.getAttribute('aria-required') !== 'true') el.setAttribute('aria-required', 'true');
      /* value arrived (autofill / variant swap) → drop a stale error */
      if (el.classList.contains('rk-req-invalid') && String(el.value || '').trim()) clearError(el);
    }
  }

  apply();
  [60, 300, 1200].forEach(function (ms) { setTimeout(apply, ms); });

  if (!window._rkReqPropsBound) {
    window._rkReqPropsBound = true;

    window.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest(CFG.BUY_SEL);
      if (!btn) return;
      if (btn.closest(CFG.SKIP_SEL)) return;
      if (guard()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);

    window.addEventListener('submit', function (e) {
      var f = form();
      if (!f || e.target !== f) return;
      if (guard()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);

    /* typing clears the error immediately */
    document.addEventListener('input', function (e) {
      var el = e.target;
      if (!el || !el.classList || !el.classList.contains('rk-req-invalid')) return;
      if (String(el.value || '').trim()) clearError(el);
    });
  }

  if (window._crowai_obs_rkpdp_reqprops) window._crowai_obs_rkpdp_reqprops.disconnect();
  var raf = null;
  window._crowai_obs_rkpdp_reqprops = new MutationObserver(function () {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(apply);
  });
  var root = document.querySelector('product-info') ||
             document.querySelector('#MainContent') || document.body;
  window._crowai_obs_rkpdp_reqprops.observe(root, { childList: true, subtree: true });
}
/* run ONLY on rakhi / raksha product pages */
(function () {
  var p = location.pathname.replace(/\/$/, "").toLowerCase();
  if (!window.__rkIsRakhiPdp(p)) return;
  if (document.readyState !== "loading") executeRakhiPdpRequiredProps();
  else document.addEventListener("DOMContentLoaded", executeRakhiPdpRequiredProps);
})();
// ===== New PDP <Required customisation text> End =====